import Avatar from "./avatar";
import { FormattedDollars } from "./formatted-currency";
import React from "react";
import { Map } from "immutable";

export function MonthlyLeaderboardList({label, players}) {

  if (players === undefined) {
    players = Map();
  }
  let playersTable;

  playersTable = players.valueSeq().map((player, index) => {
    let value;
    switch (label.toLowerCase()) {
      case "wins":
        value = player.get("wins");
        break;
      case "winnings":
        value = <FormattedDollars showCents value={player.get("winnings")} />;
        break;
    }
    return (
      <tr className="monthly-leaderboard-list-item" key={player.get("user").get("username")}>
        <td className="rank-column">
          {index + 1}
        </td>

        <td>
          <Avatar tiny user={player.get("user")} />

          {player.get("user").get("username")}
        </td>

        <td>
          {value}
        </td>
      </tr>
    );
  });

  return (
    <table className="monthly-leaderboard-table">
      <thead>
        <tr>
          <th className="rank-column">
            Rank
          </th>

          <th>
            Name
          </th>

          <th>
            {label}
          </th>
        </tr>
      </thead>

      <tbody>
        {playersTable}
      </tbody>
    </table>
  );
}
